export const axisTypes = {
  x: 'x',
  y: 'y'
};

export const radialTypes = {
  img: 'img',
  text: 'text'
};

export const lineChartTypes = { single: 'single', double: 'double' };

export const lineChartMargin = { top: 28, right: 24, left: -10, bottom: 16 };

export const legendStyle = {
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '18px',
  letterSpacing: '0px',
  textAlign: 'left'
};

export const NPSStatuses = {
  increased: 'Your Net Promoter Score has increased.',
  same: 'Your Net Promoter Score stayed the same.',
  decreased: 'Your Net Promoter Score has decreased.'
};

